export default {
  newCofContainer: {
    background: '#fff',
    textAlign: 'center',
    padding: '20px',
    '@media(min-width:801px)': {
      padding: '20px 30px'
    }
  },
  mainTitle: {
    font: data => '500 16px ' + data.fontFamily1,
    marginBottom: '20px',
    display: 'block',
    '@media(min-width:801px)': {
      fontSize: '18px',
      margin: '0 10px 10px'
    }
  },
  reservationInfo: {
    marginLeft: '10px',
    fontWeight: '500'
  },
  newCofId: {
    marginTop: '30px'
  },
  hide: {
    display: 'none'
  },
  paddedText: {
    padding: '0 0 20px',
    display: 'block',
    font: data => '300 13px ' + data.fontFamily1,
  },
  creditCard:{
    font: data => '400 18px ' + data.fontFamily1,
    color:'#8d8d8d',
    paddingTop:'25px'
  },
  goldInfo: {
    fontSize: '13px',
    textAlign: 'left'
  },
  defaultStyle: {
    background: '#fff'
  },
  pendingContainer: {
    minHeight: 'calc(100vh - 29px)',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    '@media(min-width:901px)': {
      margin: '0 auto',
      padding: '20px 10px 40px',
      overflow: 'hidden',
      maxWidth: '1190px',
      minHeight: '100vh',
      boxSizing: 'border-box',
      justifyContent: 'space-between'
    },
    '&:lang(ar)': {
      direction: 'rtl'
    },
  },
  resumeSimpleContainer: {
    padding: '0 20px 25px',
    '@media (min-width: 801px), print': {
      padding: '0 0 20px'
    }
  },
  countryContainer: {
    padding: '0 20px',
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
    '& > div':{
      height: '40px',
      minWidth: '130px',
      '& > div':{
        height: '40px!important',
      },
    },
    '@media (min-width: 541px)':{
      paddingRight: '29px',
    },
    '@media (min-width: 901px)':{
      padding: '0 20px 0 15px',
    },
  },
  cityContainer: {
    height: '40px',
    boxShadow: '0 0 2px 0 rgba(0,0,0,50%);',
    flex: '1',
    '& span':{
      display: 'none',
    },
    '& svg':{
      fill: data => data.mainColor,
    }
  },
  citySelector:{
    height: '40px',
    '& > div':{
      border: 'none',
      '& > div':{
        '& > div':{
          font: '300 13px Roboto, sans-serif',
          color: '#000',
        }
      }
    }
  },
  resumeSimple: {
    '@media (min-width: 801px), print': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding:'0 20px 0 15px'
    }
  },
  resumeInformation: {
    font: data => '300 16px ' + data.fontFamily1,
    '@media (min-width: 801px), print': {
      padding:'0 15px'
    }
  },
  title: {
    color: data => data.mainColor,
    font: data => '24px/1.13 ' + data.fontFamily1,
    maxWidth: '250px',
    margin: '0 auto',
    textAlign: 'center',
    '@media (min-width: 801px), print': {
      position: 'relative',
      paddingRight: '20px',
      minHeight: '60px',
      maxWidth: 'none',
      margin: '0',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left'
    }
  },
  locatorBox: {
    border: '1px dashed #9e9e9e',
    width: '150px',
    margin: '20px auto',
    padding: '10px 6px 8px',
    textAlign: 'left',
    '@media (min-width: 801px), print': {
      padding: '8px 12px',
      margin: 0,
    }
  },
  locatorTitle: {
    fontSize: '11px',
    color: '#9b9b9b',
    display: 'block',
    '@media (min-width: 801px), print': {
      fontSize: '11px'
    }
  },
  locatorValue: {
    fontSize: '18px',
    fontWeight: 'bold',
    wordBreak: 'break-word'
  },
  finalPrice: {
    font: data => '11px ' + data.fontFamily1,
    padding: '15px 20px',
    width:'100%',
    boxSizing:'border-box',
    '@media (min-width: 901px)': {
      padding: '20px'
    }
  },
  priceContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    padding: '15px 20px 20px',
    '@media (min-width: 901px)': {
      flex: 1,
      padding: '0',
    }
  },
  buttonContainer: {
    paddingTop: '15px',
    display: 'table-caption',
    '& > button': {
      width: '100%',
      position: 'relative',
      padding: '0 20px',
      textTransform: 'uppercase',
      letterSpacing: '.5px',
      font: data => 'normal 18px/1.13 ' + data.fontFamily1,
      '@media (min-width: 901px)': {
        maxWidth:'255px',
        height: '50px'
      }
    },
    '@media (min-width: 901px)': {
      display: 'table-cell',
      padding: '0 0 0 30px',
      width: '215px',
      verticalAlign: 'middle'
    },
  },
  noPaddingButton:{
    paddingTop:0
  },
  payContainer: {
    font: data => '300 11px ' + data.fontFamily1,
    background: '#fff',
    textAlign: 'left',
    paddingTop: '20px',
    '@media (min-width: 901px)': {
      width: '64%',
      paddingTop: 0,
      background: 'transparent'
    }
  },
  resumeContainer: {
    display: 'block',
    width: '31%',
    padding: '0 10px',
    background: '#fff',
  },
  bookIcon: {
    width: '50px',
    height: '50px',
    fill: data => data.mainColor,
    display: 'block',
    margin: '0 auto',
    '@media (min-width: 801px)': {
      width: '60px',
      height: '60px',
      position: 'absolute',
      left: '0',
      top: '0',
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        left: 'auto',
        right: 0
      }
    }
  },
  bookIconGreen:{
    composes:'$bookIcon',
    fill:'#5ca70a'
  },
  customerForm: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'flex-start',
    '@media (min-width: 901px)': {
      display: 'block',
    },
  },
  wrapperPciFrame: {
    width: '100%',
    boxSizing: 'border-box',
  },
  payComponent:{
    width:'100%'
  },
  confirmationContainer: {
    font: data => '300 13px ' + data.fontFamily1,
    paddingBottom: '20px',
    '@media (min-width: 801px), print': {
      padding: '38px 10px 20px',
      font: data => '300 13px ' + data.fontFamily1,
      background: '#f1f1f1',
      textAlign: 'center'
    }
  },
  confirmationContent:{
    borderBottom: data => '3px solid ' + data.mainColor,
    background: '#fff',
    paddingBottom: '12px',
    '@media (min-width: 801px), print': {
      boxShadow:'0 3px 4px 0 rgba(0, 0, 0, 0.3)',
      borderBottom: data => '3px solid ' + data.mainColor,
      paddingBottom: '30px',
      maxWidth: '1000px',
      margin: '0 auto',
      display: 'table',
      width: '100%'
    }
  },
  customer: {
    padding: '20px 10px 18px',
    '@media (min-width: 801px), print': {
      display: 'table-cell',
      textAlign: 'left',
      verticalAlign: 'bottom',
      padding: '23px 0 0 20px'
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        paddingLeft: 0,
        paddingRight: '20px',
        textAlign: 'right'
      }
    }
  },
  titleConfirmation: {
    marginBottom: '13px',
    color: '#5ca70a',
    font: data => '24px/1.13 ' + data.fontFamily1,
    '& > div': {
      textAlign: 'center',
      '@media (min-width: 801px), print': {
        textAlign: 'left'
      },
      '&:lang(ar)': {
        '@media (min-width: 801px)': {
          textAlign: 'right'
        }
      }
    },
    '@media (min-width: 801px), print': {
      display: 'block',
      position: 'relative',
      minHeight: '60px'
    }
  },
  bodyConfirmation: {
    textAlign: 'center',
    '@media (min-width: 801px), print': {
      boxSizing:'content-box',
      marginRight: '100px',
      border: '0',
      color: 'inherit',
      padding: '0',
      textAlign: 'left'
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        textAlign: 'right',
        marginLeft: '100px',
        marginRight: 0
      }
    }
  },
  email: {
    padding: '0',
    textDecoration: 'none',
    margin: '0 0 0 3px',
    color: '#000',
    fontWeight: '500',
    border: '0',
    '&:lang(ar)': {
      marginRight: '3px',
      marginLeft: 0
    }
  },
  simpleBookingInfo: {
    '@media (min-width: 801px), print': {
      display: 'table-cell',
      verticalAlign: 'bottom',
      paddingRight: '20px',
      width: '350px'
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        paddingRight: 0,
        paddingLeft: '20px'
      }
    }
  },
  locatorBoxConfirmation:{
    composes:'$locatorBox',
    marginLeft:'auto'
  },
  bookIconConfirmation:{
    composes:'$bookIcon',
    fill:'#5ca70a',
  },
  tableContainer: {
    display: 'table',
    width: '100%',
    captionSide: 'bottom',
    '& > span': {
      display: 'block',
      textAlign: 'right',
      fontSize: '14px',
      color: '#333'
    },
    '@media (min-width: 901px)': {
      textAlign:'right'
    },
  },
  tableCell: {
    display: 'table-cell',
    verticalAlign: 'bottom',
    '@media (min-width: 901px)': {
      textAlign:'left'
    },
    '&:first-of-type': {
      '& > span:first-of-type': {
        paddingBottom: '5px'
      }
    },
    '&:nth-of-type(2)': {
      textAlign: 'right',
      '&:lang(ar)': {
        textAlign: 'left'
      },
    }
  },
  subtitleConfirmation:{
    fontWeight:'300',
    fontSize:'16px',
    color:'#000'
  }
};
